"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FEDERALLY_INSURED_DESCRIPTIONS", {
  enumerable: true,
  get: function get() {
    return _constants.FEDERALLY_INSURED_ANNOTATIONS;
  }
});
Object.defineProperty(exports, "FORMATS", {
  enumerable: true,
  get: function get() {
    return _drivers.FORMATS;
  }
});
exports.TRK_PRODUCT_LOCATION = void 0;
Object.defineProperty(exports, "VALUE_SIZES", {
  enumerable: true,
  get: function get() {
    return _drivers.VALUE_SIZES;
  }
});
var _drivers = require("@nerdwallet/marketplace/constants/drivers");
var _constants = require("@nerdwallet/marketplace/constants");
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/constants` directly.
 */

var TRK_PRODUCT_LOCATION = 'QuickFacts';
exports.TRK_PRODUCT_LOCATION = TRK_PRODUCT_LOCATION;